import React from 'react';
import CheckCircleFill from '@mds/icons/CheckCircleFill';
import {
    Box,
    Card,
    CardActionArea,
    CardContent,
    Chip,
    Stack,
    Typography,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { ChannelCoverImage } from '../../ui/ChannelCoverImage';

interface ChannelCardProps {
    name: string;
    owner: string;
    url: string;
    image?: string;
    premium?: boolean;
    isSubscribed?: boolean;
    fullHeight?: boolean;
}

export const ChannelCard = ({
    name,
    owner,
    url,
    premium,
    isSubscribed,
    image,
    fullHeight = false,
}: ChannelCardProps) => (
    <Card
        variant="outlined"
        sx={{
            height: fullHeight ? '100%' : undefined,
            overflow: 'hidden',
            bgcolor: 'background.paper',
        }}
    >
        <CardActionArea
            component={RouterLink}
            nativeButton={false}
            to={url}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'stretch',
                height: fullHeight ? '100%' : undefined,
            }}
        >
            <Box
                sx={{
                    position: 'relative',
                    width: '100%',
                    height: 160,
                    overflow: 'hidden',
                }}
            >
                <Box
                    component={ChannelCoverImage}
                    src={image}
                    alt={name}
                    sx={{
                        display: 'block',
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                    }}
                />
                <Stack
                    direction="row"
                    sx={{
                        gap: 1,
                        flexWrap: 'wrap',
                        position: 'absolute',
                        top: 16,
                        left: 16,
                        right: 16,
                        justifyContent: 'space-between',
                    }}
                >
                    {premium && (
                        <Chip label="Premium" color="primary" size="small" />
                    )}
                    {isSubscribed && (
                        <Chip
                            label="Subscribed"
                            color="success"
                            size="small"
                            icon={<CheckCircleFill />}
                        />
                    )}
                </Stack>
            </Box>
            <CardContent
                sx={{
                    flex: fullHeight ? 1 : undefined,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                }}
            >
                <Typography variant="h6" component="h3">
                    {name}
                </Typography>
                <Typography
                    variant="body2"
                    sx={{
                        color: 'text.secondary',
                    }}
                >
                    Published by {owner}
                </Typography>
            </CardContent>
        </CardActionArea>
    </Card>
);

export default ChannelCard;
